// eslint-disable-next-line unicode-bom
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "../../store/thunk/changePassword";
import { selectUserDetails } from "../../Selectors/Selector";
import { useSelector } from "react-redux";
import { response } from "../../store/actions/action";
import { useNavigate } from "react-router-dom";

function ChangePassword() {
    const userDetails = useSelector(selectUserDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const onClickChangePassword = (e) => {
        e.preventDefault();
        if (userDetails) {

            setIsLoading(true);
            if (newPassword === confirmNewPassword) {
                const passwordDetails = {
                    Email: userDetails.email,
                    OldPassword: oldPassword,
                    NewPassword: newPassword
                }
                dispatch(changePassword(passwordDetails)).then((res) => {
                    if (res.payload) {
                        setOldPassword('');
                        setNewPassword('');
                        setConfirmNewPassword('');
                        dispatch(response("Password changed successfully."))
                    }
                });
            }
            else {
                //throwError
            }
            setIsLoading(false);
        }
        else {
            navigate('/')
        }
    }
    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-none d-md-block">
                    <div className="row mb-md-5">
                        <div className="col">
                            <h5 className="mb-1 text-white">Change Password</h5>
                            <p className="mb-0 text-white small">
                                You have full control to manage your own account setting.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <form id="setting_form" method="POST" action="#" novalidate="novalidate">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <label htmlFor="" className="form-label">Old Password</label>
                                        <input required="" className="form-control" name="old_password" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <label htmlFor="" className="form-label">New Password</label>
                                        <input required="" className="form-control" id="new_password" name="new_password" type="text" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <label htmlFor="" className="form-label">Confirm Password</label>
                                        <input required="" className="form-control" name="confirm_password" type="password" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group text-right mb-0">
                                <button id="setting_form_btn" className="btn btn-primary btn-full btn-medium rounded" type="submit" onClick={(e) => onClickChangePassword(e)} disabled={isLoading}>
                                    <span className={`${isLoading ? `spinner-border` : ``} spinner-border-sm`} role="status" aria-hidden="true"></span>
                                    Change Password
                                </button>
                                {/* <button id="setting_form_btn" type="submit" className="btn btn-primary btn-medium" onClick={(e) => onClickChangePassword(e)}>Change Password</button> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    );
}
export default ChangePassword;